import React from 'react';
export function RevelacionSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <div className="max-w-3xl mx-auto text-center space-y-6 text-xl md:text-2xl text-gray-800 leading-relaxed" data-id="element-127">
          <p data-id="element-128">
            Cuando las personas hacen este ejercicio por primera vez descubren
            algo sorprendente:
          </p>
          <br data-id="element-129" />
          <p className="font-bold text-gray-900" data-id="element-130">
            Gran parte de su día está ocupado en actividades que no generan
            crecimiento.
          </p>
          <br data-id="element-131" />
          <p data-id="element-132">Y mientras eso no cambie…</p>
          <br data-id="element-133" />
          <p className="text-[#FF6B00] font-bold text-2xl md:text-3xl" data-id="element-134">
            el negocio se estanca.
          </p>
        </div>
      </div>
    </section>;
}